import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c7fb7bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "right-menu" }
const _hoisted_3 = { class: "avatar-wrapper" }
const _hoisted_4 = { class: "user-name-wrapper" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("退出登录")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hamburger = _resolveComponent("hamburger")!
  const _component_breadcrumb = _resolveComponent("breadcrumb")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_hamburger, {
      id: "hamburger-container",
      class: "hamburger-container",
      "is-active": _ctx.sidebar.opened,
      onToggleClick: _ctx.toggleSideBar
    }, null, 8, ["is-active", "onToggleClick"]),
    _createVNode(_component_breadcrumb, {
      id: "breadcrumb-container",
      class: "breadcrumb-container"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_dropdown, {
        class: "avatar-container right-menu-item hover-effect",
        trigger: "click",
        onVisibleChange: _ctx.visibleChange,
        onCommand: _ctx.onHandleCommandClick
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { command: "loginout" }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_avatar, {
              src: _ctx.userAvatar,
              fit: "fill",
              size: 40,
              class: "user-avatar",
              shape: "circle"
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(_ctx.userAccount), 1),
              _createVNode(_component_svg_icon, {
                "icon-class": "arrow-down",
                class: _normalizeClass({ 'arrow-down': true, 'arrow-down-show': _ctx.dropdownShow })
              }, null, 8, ["class"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onVisibleChange", "onCommand"])
    ])
  ]))
}